const ADMIN_API_PROXY_URL = 'https://meteor-node-shopify-proxy.vercel.app/sofiedumont';

class AdminAPI {
  /**
   * @param {Object} [options]
   * @param {string} [options.proxyUrl] - Override the default proxy URL
   */
  constructor(options = {}) {
    this.proxyUrl = options.proxyUrl || ADMIN_API_PROXY_URL;
  }

  /**
   * @param {string} graphqlQuery - The GraphQL query string
   * @param {Object} variables - Query variables
   * @returns {Promise<Object>} - Parsed JSON response data
   */
  async query(graphqlQuery, variables = {}) {
    if (!this.proxyUrl) {
      throw new Error('AdminAPI: proxyUrl is not configured');
    }

    const response = await fetch(this.proxyUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: graphqlQuery, variables })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data.errors) {
      throw new Error(`GraphQL query failed: ${data.errors[0]?.message}`);
    }

    return data.data;
  }

  /**
   * @param {string} graphqlQuery - The GraphQL query string
   * @param {Object} variables - Base query variables (must include `first`, may include `after`)
   * @param {Function} getPageInfo - Extracts { nodes, hasNextPage, endCursor } from response data
   * @param {string|null} [cursor] - Starting cursor
   * @returns {Promise<Array>} - All accumulated nodes across pages
   */
  async queryAll(graphqlQuery, variables, getPageInfo, cursor = null) {
    const allNodes = [];
    const state = { cursor, hasNextPage: true };

    while (state.hasNextPage) {
      const pageVariables = { ...variables, after: state.cursor };
      const data = await this.query(graphqlQuery, pageVariables);
      const pageInfo = getPageInfo(data);
      allNodes.push(...pageInfo.nodes);
      state.hasNextPage = pageInfo.hasNextPage;
      state.cursor = pageInfo.endCursor;
    }

    return allNodes;
  }

}

window.AdminAPI = AdminAPI;
